<template>
  <div class="fadein">
    <div class="gotop" @click="gotop" style="display: none;"></div>
    <link rel="stylesheet" href="/static/css/index.css" />
    <!-- 滚动条 start -->
    <div class="h30"></div>
    <div class="center1200">
      <div class="block banner">
        <el-carousel height="500px" type="card">
          <!-- <div>最新电影</div> -->
          <el-carousel-item>
            <router-link to="/forumdetail/3">
              <img src="/static/img/movie02.jpg" alt="" />
            </router-link>
          </el-carousel-item>
          <el-carousel-item>
            <router-link to="/forumdetail/4">
              <img src="/static/img/movie01.jpg" alt="" />
            </router-link>
          </el-carousel-item>
          <el-carousel-item>
            <router-link to="/forumdetail/2">
              <img src="/static/img/movie03.jpg" alt="" />
            </router-link>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div style="clear:both"></div>
    <div class="h30"></div>
    <!-- 滚动条 end -->

    <!-- temp-1 start-->
    <div class="center1200 bg-white temp-1 shadow">
      <div class="h20"></div>
      <div class="center-title">
        <a href="#">
          <img class="title-pic" src="/static/img/title-left.png" alt="" />
          最新电影
          <img class="title-pic" src="/static/img/title-right.png" alt="" />
        </a>
      </div>
      <div class="h20"></div>
      <div class="movieboxes">
        <div class="moviebox" v-for="v in new_movies">
          <a href="javascript:;" @click="goMovieDetail(v.id)">
            <img :src="v.cover" alt="" class="moviepic" />
          </a>
          <a href="" @click="goMovieDetail(v.id)">{{ v.title }}</a>
          <p>
            <span v-for="val in v.withtypes">
              {{ val.type }}
            </span>
          </p>
        </div>
      </div>

      <div class="h10"></div>
    </div>
    <!-- temp-1 end-->
    <div class="h20"></div>
    <!-- temp-4 start-->
    <div class="center1200 temp-2">
      <div class="bg-white ">
        <div class="hot-forum shadow">
          <div class="center-title">
            <router-link to="/forum"
              ><img class="title-pic" src="/static/img/title-left.png" alt=""/>
              活跃论坛
              <img class="title-pic" src="/static/img/title-right.png" alt=""
            /></router-link>
          </div>
          <div class="h20"></div>
          <ul>
            <li v-for="(v, k) in hot_forum">
              <a href="javascript:;" @click="goForumDetail(v.id)"
                ><img :src="getTopImg(k + 1)" alt="" class="top5" />{{
                  v.title
                }}</a
              >
              <div class="gray">
                <i class="el-icon-view"></i> {{ v.reviews_count }}
              </div>
            </li>
          </ul>
        </div>
        <div class="h20" style="background: #f5f5f5;"></div>
        <div class="user-recommend shadow" style="padding:0 10px;width:350px;">
          <div class="h20"></div>
          <div class="center-title">
            <a href="javascript:;"
              ><img class="title-pic" src="/static/img/title-left.png" alt=""/>
              用户推荐
              <img class="title-pic" src="/static/img/title-right.png" alt=""
            /></a>
          </div>
          <div class="h20"></div>
          <ul>
            <li v-for="v in rec_users">
              <div>
                <img
                  :src="v.extras.user_pic"
                  alt=""
                  class="rec-head"
                  v-if="v.extras.user_pic != 'http://' + $API_URL"
                  @click="goUserinfo(v.id)"
                />
                <img
                  src="/static/img/default_userpic.png"
                  alt=""
                  class="rec-head"
                  v-else
                  @click="goUserinfo(v.id)"
                />
              </div>

              <p>
                <span
                  v-if="v.extras.nickname != null"
                  @click="goUserinfo(v.id)"
                  >{{ v.extras.nickname }}</span
                ><span v-else @click="goUserinfo(v.id)">{{ v.mobile }}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div class="bg-white shadow" style="width:810px;">
        <div class="h20"></div>
        <div class="center-title">
          <a href="javascript:;"
            ><img class="title-pic" src="/static/img/title-left.png" alt=""/>
            热门电影
            <img class="title-pic" src="/static/img/title-right.png" alt=""
          /></a>
        </div>
        <div class="h20"></div>

        <div class="movieboxes">
          <div v-for="(v, k) in hot_movies">
            <div class="h30" v-if="k >= 4"></div>
            <div class="moviebox">
              <a href="javascript:;" @click="goMovieDetail(v.id)">
                <img :src="v.cover" alt="" class="moviepic" />
              </a>
              <a href="" @click="goMovieDetail(v.id)">{{ v.title }}</a>
              <p>
                <span v-for="val in v.withtypes">
                  {{ val.type }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <!-- <div class="h10" style="background: #eee;margin-top:20px;"></div> -->
        <!-- <div class="h10" style="background: #eee;margin-top:20px;"></div> -->
      </div>
    </div>
    <!-- temp-4 end-->
    <div class="h20"></div>

    <!-- temp-2 start -->
    <div class="center1200 temp-2">
      <div class="bg-white shadow" style="width:810px;">
        <div class="h20"></div>

        <div class="center-title">
          <a href="javascript:;"
            ><img class="title-pic" src="/static/img/title-left.png" alt=""/>
            电影推荐
            <img class="title-pic" src="/static/img/title-right.png" alt=""
          /></a>
        </div>
        <div class="h20"></div>

        <div class="movieboxes">
          <div class="moviebox" v-for="v in rec_movies">
            <a href="javascript:;" @click="goMovieDetail(v.id)">
              <img :src="v.cover" alt="" class="moviepic" />
            </a>
            <a href="" @click="goMovieDetail(v.id)">{{ v.title }}</a>
            <p>
              <span v-for="val in v.withtypes">
                {{ val.type }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white shadow" style="width:370px;float:right;">
        <div class="hot-forum">
          <div class="center-title">
            <router-link to="/forum"
              ><img class="title-pic" src="/static/img/title-left.png" alt=""/>
              今日话题
              <img class="title-pic" src="/static/img/title-right.png" alt=""
            /></router-link>
          </div>
          <div class="h20"></div>

          <ul>
            <li v-for="v in topics">
              <a href="javascript:;" @click="goTopicDetail(v.id)">
                {{ v.title }}</a
              >
              <div class="gray">
                <i class="el-icon-view"></i> {{ v.reviews_count }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- temp-2 end -->

    <div class="h20"></div>
    <!-- temp-3 start -->
    <div class="center1200 bg-white temp-1 shadow">
      <div class="h20"></div>
      <div class="center-title">
        <router-link to="/category">
          <img class="title-pic" src="/static/img/title-left.png" alt="" />
          分类专区
          <img class="title-pic" src="/static/img/title-right.png" alt="" />
        </router-link>
      </div>
      <div class="h20"></div>

      <div class="categorys">
        <div class="category" v-for="v in categories">
          <a href="javascript:;" @click="goCategory(v.name)">{{ v.name }}</a>
        </div>
      </div>

      <div class="h10"></div>
    </div>
    <!-- temp-3 end -->

    <div class="h20"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //最新电影
      new_movies: {},
      categories: [],
      //热门电影
      hot_movies: {},
      //推荐电影
      rec_movies: [],
      //推荐用户
      rec_users: [],
      //活跃论坛
      hot_forum: [],

      //今日话题
      topics: []
    };
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.name == "index") {
        this.$parent.activeIndex = "1";
        this.getHotForum();
        this.getTopics();
      }
      if (oldVal.name == "index") {
        this.scrollTop = 0;
      }
    }
  },
  mounted() {
    this.$parent.activeIndex = "1";
    //
    // 获取热门电影
    this.getHotMovies();
    // 获取最新电影
    this.getNewMovies();
    // 获取推荐电影
    this.getRecMovies();
    // 获取推荐用户
    this.getRecUsers();
    // 获取分类
    this.getCategory();
    // 获取活跃论坛
    this.getHotForum();
    // 获取今日话题
    this.getTopics();

    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    //去电影详情
    goMovieDetail(id) {
      //
      this.$router.push("/movie/" + id);
    },
    //分类专区
    getCategory() {
      var names = [
        "喜剧",
        "冒险",
        "科幻",
        "悬疑",
        "惊悚",
        "记录",
        "战争",
        "剧情",
        "恐怖",
        "动作",
        "音乐",
        "更多"
      ];
      // var bg = "background-image:url('/static/img/lighting.png')"
      // var bg = "background-image:url('/static/img/sorts/example.png');"
      var bg = "";
      for (var i = 0; i < 12; i++) {
        //
        this.categories.push({ name: names[i] });
      }
      //
    },
    //去分类详情
    goCategory(keyword) {
      console.log(keyword);
      if (keyword == "更多") {
        this.$router.push("/category");
      } else {
        this.$router.push("/categorydetail/" + keyword);
      }
    },
    //获取热门电影
    getHotMovies() {
      $.ajax({
        url: "/api/v1/movies/hot",
        type: "get",
        success: ret => {
          this.hot_movies = ret;
        }
      });
    },
    //获取活跃论坛
    getHotForum() {
      $.ajax({
        url: "/api/v1/articles/get_hot_articles",
        type: "get",
        success: ret => {
          this.hot_forum = ret.data;
        }
      });
    },
    getTopImg(k) {
      return "/static/img/top/" + k + ".png";
    },

    // 获取今日话题
    getTopics() {
      $.ajax({
        url: "/api/v1/votes/get_hot_votes",
        type: "get",
        success: ret => {
          this.topics = ret.data;
        }
      });
    },
    // 获取最新电影
    getNewMovies() {
      $.ajax({
        url: "/api/v1/movies",
        type: "get",
        // data:{page:1},
        success: ret => {
          //
          this.new_movies = ret.data;
        }
      });
    },
    //获取推荐电影
    getRecMovies() {
      $.ajax({
        url: "/api/v1/movies/recommend",
        type: "get",
        success: ret => {
          this.rec_movies = ret;
        }
      });
    },
    //获取推荐用户
    getRecUsers() {
      if (localStorage.getItem("token")) {
        $.ajax({
          url: "/api/v1/users/recommend",
          type: "post",
          data: { user_id: this.token },
          success: ret => {
            this.rec_users = ret.data;
          }
        });
      } else {
        $.ajax({
          url: "/api/v1/users/recommend",
          type: "post",
          success: ret => {
            this.rec_users = ret.data;
          }
        });
      }
    },
    //点击用户名或头像跳转到用户信息页
    goUserinfo(uid) {
      this.$router.push("/user/" + uid).catch(err => {
        err;
      });
    },
    //跳转到论坛详情
    goForumDetail(fid) {
      this.$router.push("/forumdetail/" + fid).catch(err => {
        err;
      });
    },
    // 回到顶部
    gotop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 1);
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      // if (that.scrollTop==0){
      //   $(".gotop").fadeOut(0);
      // }
      if (that.scrollTop > 500) {
        //   that.gotopFlag = false
        $(".gotop").fadeIn(250);
      } else {
        //   that.gotopFlag = true
        $(".gotop").fadeOut(250);
      }
    },
    //跳转到话题详情
    goTopicDetail(tid) {
      this.$router.push("/topicdetail/" + tid).catch(err => {
        err;
      });
    }
  }
};
</script>
<style scoped>
.top5 {
  vertical-align: middle;
  margin-right: 5px;
}
/* carousel start */
.moviebox {
  width: 172px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item {
  width: 1000px;
  height: 500px;
  margin-left: -17%;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
/* carousel end */
* {
  margin: 0;
  padding: 0;
  font-family: "PingFang SC";
}

.banner {
  width: 1200px;
  height: 530px;
}

.temp-2 {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
}

.hot-forum {
  /* float:right; */
  width: 320px;
  height: 390px;
  padding: 25px 25px 10px 25px;
}
.hot-forum ul {
  list-style: none;
  color: #4a4b4d;
}
.hot-forum ul li {
  height: 60px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #ddd;
}
.hot-forum ul li:nth-child(5) {
  border-bottom: none;
}
.hot-forum ul li a {
  text-decoration: none;
  color: #3c3c3b;
  transition: 0.25s;
}
.hot-forum ul li a:hover {
  color: #ff7400;
  transition: 0.25s;
}
.gray {
  color: #999;
}

.user-recommend {
  float: right;
  width: 320px;

  background: #fff;
  padding: 25px 25px 10px 25px;
}
.user-recommend ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}
.user-recommend ul li {
  text-align: center;
  list-style: none;
  margin-bottom: 20px;
  text-align: center;
  width: 105px;
}
.user-recommend ul li div {
  margin: 0 auto;
  width: 85px;
  height: 85px;
  border-radius: 50%;
  border: 1px solid #fff;
  transition: 0.5s;
}
.user-recommend ul li p {
  margin: 0 auto;
  text-align: center;
  /* width:107px; */
  font-weight: 500;
  line-height: 20px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  color: #300133;
  /* width:85px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-recommend ul li:hover p {
  transition: 0.5s;
  color: #ff7400;
  /* border:1px solid #ff7400; */
}
.user-recommend ul li:hover div {
  border: 1px solid #ff7400;
}
.rec-head {
  cursor: pointer;

  width: 85px;
  height: 85px;
  border-radius: 50%;
  /* border:1px solid #fff; */
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue